import { memo } from 'react'
import { TFunction, useTranslation } from 'next-i18next'

import { usePageTitle } from '~/utils/tags'

import Metatags from './Metatags'
import { MetaImage } from './Metadata.types'

export enum SubjectType {
  MATH = 'math',
  STATISTICS = 'statistics',
  PHYSICS = 'physics',
  FINANCE = 'finance',
  ECONOMY = 'economy',
  OTHER_SUBJECTS = 'other-subjects',
  CHEMISTRY = 'chemistry',
  BIOLOGY = 'biology',
}

export function getSubjectImage(type: SubjectType, t: TFunction): MetaImage {
  let srcKey = ''
  let alt
  switch (type) {
    case SubjectType.MATH:
      srcKey = 'mentor-on-demand/icons/math.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.math')
      break
    case SubjectType.STATISTICS:
      srcKey = 'mentor-on-demand/icons/statistics-v2.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.statistics')
      break
    case SubjectType.PHYSICS:
      srcKey = 'mentor-on-demand/icons/physics.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.physics')
      break
    case SubjectType.FINANCE:
      srcKey = 'mentor-on-demand/icons/finance.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.finance')
      break
    case SubjectType.ECONOMY:
      srcKey = 'mentor-on-demand/icons/economy.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.economy')
      break
    case SubjectType.OTHER_SUBJECTS:
      srcKey = 'mentor-on-demand/icons/other-subjects.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.otherSubjects')
      break
    case SubjectType.CHEMISTRY:
      srcKey = 'mentor-on-demand/icons/chemistry.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.chemistry')
      break
    case SubjectType.BIOLOGY:
      srcKey = 'mentor-on-demand/icons/biology.svg'
      alt = t('tutorOnDemand:landingPage.iconAlts.biology')
      break
  }
  return { srcKey, alt }
}

const SubjectMetatags = ({
  title,
  metaDescription,
  type,
}: {
  title: string
  metaDescription?: string
  type: SubjectType
}): React.ReactElement => {
  const { t } = useTranslation(['tutorOnDemand'])
  const image = getSubjectImage(type, t)
  return <Metatags image={image} metaDescription={metaDescription} title={usePageTitle(title)} />
}

export default memo(SubjectMetatags)
